const exportState = (state) => state.export

export const exportSelectors = {
    isExporting: (state) => exportState(state).isExporting,
    notice: (state) => exportState(state).notice,
    error: (state) => exportState(state).error,
}
